import './BrandsStrip.css';
import LogoLoop from '../LogoLoop';
import {
  SiShopify, SiWoocommerce, SiStripe, SiWordpress,
  SiReact, SiNextdotjs, SiTailwindcss, SiWebflow,
  SiGoogleanalytics, SiMailchimp, SiZapier, SiFigma,
} from 'react-icons/si';

const BRANDS = [
  { icon: SiShopify,          name: 'Shopify',    color: '#96bf48' },
  { icon: SiWoocommerce,      name: 'WooCommerce', color: '#7f54b3' },
  { icon: SiStripe,           name: 'Stripe',     color: '#635bff' },
  { icon: SiWordpress,        name: 'WordPress',  color: '#21759b' },
  { icon: SiReact,            name: 'React',      color: '#06b6d4' },
  { icon: SiNextdotjs,        name: 'Next.js',    color: '#374151' },
  { icon: SiTailwindcss,      name: 'Tailwind',   color: '#0ea5e9' },
  { icon: SiWebflow,          name: 'Webflow',    color: '#4353ff' },
  { icon: SiGoogleanalytics,  name: 'Analytics',  color: '#e37400' },
  { icon: SiMailchimp,        name: 'Mailchimp',  color: '#f59e0b' },
  { icon: SiZapier,           name: 'Zapier',     color: '#ff4a00' },
  { icon: SiFigma,            name: 'Figma',      color: '#f24e1e' },
];

export default function BrandsStrip() {
  return (
    <div className="brands-strip">
      <div style={{ height: '68px', position: 'relative', overflow: 'hidden', width: '100%' }}>
        <LogoLoop
          logos={BRANDS.map(({ icon: Icon, name, color }) => ({
            node: (
              <div className="brand-item" style={{ '--brand-color': color }}>
                <Icon className="brand-icon" />
                <span className="brand-name">{name}</span>
              </div>
            ),
          }))}
          speed={50}
          direction="left"
          logoHeight={22}
          gap={8}
          hoverSpeed={0}
          fadeOut
          fadeOutColor="#ffffff"
          ariaLabel="Tools and platforms"
        />
      </div>
    </div>
  );
}
